export default "__VITE_ASSET__CcmEBbWx__"